import React from "react";
import { Modal, Button } from "react-bootstrap";

const ReasonModal = ({ show, onHide, description }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Reason</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="reason-text">{description || "No error details recorded"}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReasonModal;
